import { Boxes, Calculator, ClipboardList, Link2, MoreHorizontal, Printer, ShoppingCart, Trash2 } from 'lucide-react'

/**
 * The icon each material action shows, on the material rows and in Master Data
 * Config → Actions, so the switch a tenant flips looks like the button it hides.
 */
const ACTION_ICONS: Record<string, React.ElementType> = {
  printLabel: Printer,
  order: ShoppingCart,
  stock: Boxes,
  // Reorder: the re-order calculation. Red on the row while the material is at
  // or below its reorder point or out of stock.
  replenish: Calculator,
  connect: Link2,
  // Purchase Order (z8nrz7f7dz), straight to the order form.
  po: ClipboardList,
  delete: Trash2,
}

/** The icon for an action key; a tenant's own action gets a generic dots icon. */
export function actionIcon(key: string): React.ElementType {
  return ACTION_ICONS[key] ?? MoreHorizontal
}
